import { BookOpen } from "lucide-react";
import type * as React from "react";

import { Badge, type Color } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";


interface Props {
  href?: string;
  className?: string;
  label?: string;
  color?: Color;
  variant?: "default" | "regular" | "secondary" | "destructive" | "outline" | "fancy";
  asButton?: boolean;
  buttonVariant?: React.ComponentProps<typeof Button>["variant"];
  buttonSize?: React.ComponentProps<typeof Button>["size"];
}

export default function TutorialBadge({
  href = "/user-manual",
  className,
  label = "Manual de uso",
  color = "indigo",
  variant = "outline",
  asButton = false,
  buttonVariant = "outline",
  buttonSize = "sm",
}: Props) {
  if (asButton) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Button asChild variant={buttonVariant} size={buttonSize} className={cn(className)}>
            <a href={href} target="_blank" rel="noopener noreferrer">
              <BookOpen className="h-3.5 w-3.5" /> {label}
            </a>
          </Button>
        </TooltipTrigger>
        <TooltipContent>Guía paso a paso de la herramienta</TooltipContent>
      </Tooltip>
    );
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={cn("inline-flex", className)}
        >
          <Badge variant={variant} color={color} className="gap-1">
            <BookOpen className="h-3.5 w-3.5" /> {label}
          </Badge>
        </a>
      </TooltipTrigger>
      <TooltipContent>Guía paso a paso de la herramienta</TooltipContent>
    </Tooltip>
  );
}
